import styled from 'styled-components'
import { GREEN, GREY_DARK } from '../../utils/colors'
import { SM } from '../../utils/screenSizes'

export const LoadingElement = styled.div`
  height: 179px;
  padding: 10px;

  .skeleton {
    width: 100%;
    display: block;
    height: 159px;
  }
`
export const Container = styled.div`
  display: grid;
  grid-template-columns: 0.9fr 1fr auto;
  gap: 0px 22px;
  align-items: center;

  padding: 30px;
  border-bottom: 1px solid #ececec;

  @media (max-width: ${SM}) {
    display: block;
    text-align: center;
  }

  .button {
    padding-top: 11px;
    padding-bottom: 11px;
  }

  .plan_name {
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    line-height: 1.5;
    color: ${GREY_DARK};
    margin-top: -25px;

    @media (max-width: ${SM}) {
      margin-top: 0;
    }
  }

  .plan_items {
    width: 215px;
    margin-right: 48px;
    font-size: 12px;
    line-height: 2.08;
    color: ${GREY_DARK};

    @media (max-width: ${SM}) {
      margin: 0 auto;
      width: 100%;
      margin-top: 16px;
    }
  }

  .plan_price {
    color: ${GREEN};
    align-items: flex-start;
    font-family: Mont, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 50px;
    line-height: 150%;
    letter-spacing: -3.5px;
    position: relative;

    span {
      position: relative;
      display: inline-block;
      top: -20px;
      font-size: 30px;
    }
  }
`
